import { render, staticRenderFns } from "./ChartCaption.vue?vue&type=template&id=2f5258ff"
import script from "./ChartCaption.vue?vue&type=script&lang=js"
export * from "./ChartCaption.vue?vue&type=script&lang=js"
import style0 from "./ChartCaption.vue?vue&type=style&index=0&id=2f5258ff&prod&lang=postcss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports